// extracted by mini-css-extract-plugin
module.exports = {"majorContainer":"Contact_majorContainer__1J2yc","headerContainer":"Contact_headerContainer__2rJIm","cardContainer":"Contact_cardContainer__3vI7v","card":"Contact_card__2U1UL"};